var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSocialVideoYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31 9.92022C31 8.70376 30.5168 7.53713 29.6566 6.67696C28.7964 5.81679 27.6298 5.33356 26.4133 5.33356H5.58667C4.98434 5.33356 4.38791 5.45219 3.83143 5.6827C3.27495 5.9132 2.76931 6.25105 2.3434 6.67696C1.48324 7.53713 1 8.70376 1 9.92022V22.0802C1 23.2967 1.48324 24.4633 2.3434 25.3235C2.76931 25.7494 3.27495 26.0873 3.83143 26.3178C4.38791 26.5483 4.98434 26.6669 5.58667 26.6669H26.4133C27.6298 26.6669 28.7964 26.1837 29.6566 25.3235C30.5168 24.4633 31 23.2967 31 22.0802V9.92022ZM12.6667 21.2536V9.70689L21.6933 15.4802L12.6667 21.2536Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialVideoYoutube);
export default __webpack_public_path__ + "static/media/SocialVideoYoutube.1d18ebdba1c9ea9464b460c0408686f4.svg";
export { ForwardRef as ReactComponent };